import React from 'react';
import { format, parseISO } from 'date-fns';
import { CheckCircle } from 'lucide-react';

export default function StudentPayments({ studentDetails }) {
  const { payment_date, payment_amount } = studentDetails;

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h2 className="text-2xl font-semibold mb-4">My Payment</h2>
      {payment_date && payment_amount ? (
        <div className="flex items-center bg-gray-50 p-4 rounded-md">
          <CheckCircle className="text-green-500 w-6 h-6 mr-3" />
          <div className="flex-grow">
            <p className="font-semibold text-green-600">Success</p>
            <p className="text-sm text-gray-600">
              {format(parseISO(payment_date), 'MMMM d, yyyy')}
            </p>
          </div>
          <p className="text-lg font-semibold">₹{parseFloat(payment_amount).toFixed(2)}</p>
        </div>
      ) : (
        <p className="text-gray-600">No payment information found.</p>
      )}
    </div>
  );
}